"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Geometry = /** @class */ (function () {
    function Geometry(x, y, w, h) {
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
    }
    return Geometry;
}());
exports.Geometry = Geometry;
var Position = /** @class */ (function () {
    function Position(x, y) {
        this.x = x;
        this.y = y;
    }
    return Position;
}());
exports.Position = Position;
exports.PerfectScrollbarEvents = [
    'ps-scroll-y',
    'ps-scroll-x',
    'ps-scroll-up',
    'ps-scroll-down',
    'ps-scroll-left',
    'ps-scroll-right',
    'ps-y-reach-end',
    'ps-y-reach-start',
    'ps-x-reach-end',
    'ps-x-reach-start'
];
var PerfectScrollbarConfig = /** @class */ (function () {
    function PerfectScrollbarConfig(config) {
        if (config === void 0) { config = {}; }
        this.assign(config);
    }
    PerfectScrollbarConfig.prototype.assign = function (config) {
        if (config === void 0) { config = {}; }
        for (var key in config) {
            this[key] = config[key];
        }
    };
    return PerfectScrollbarConfig;
}());
exports.PerfectScrollbarConfig = PerfectScrollbarConfig;
//# sourceMappingURL=perfect-scrollbar.interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-perfect-scrollbar/dist/lib/perfect-scrollbar.interfaces.js
// module id = 107
// module chunks = 3